import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {ResponseCode} from "@app/constants/Common";
import {requestAddCandidateIntoGroup} from "@app/services/CandidateGroupService";
import Select from "react-select";
import {SavedListLevels, SavedListTabOptions} from "@pages/savedlist/common/Constant";
import {alertMessage, showMessage} from "@app/constants/Messages";

const AddCandidateIntoGroupModal = (props) => {
    const [groupSelectId, setGroupSelectId] = useState('new')
    const [isCreateNewGroup, setCreateNewGroup] = useState(true)
    const [groupSelectOptions, setGroupSelectOptions] = useState([])
    const [groupName, setGroupName] = useState('')
    const [tab, setTab] = useState('')
    const [level, setLevel] = useState('')

    const [isLoading, setIsLoading] = useState(false)
    const {isShow, createNewGroup} = props
    const {candidateId} = props
    const {groups} = props
    const {onClose} = props

    useEffect(() => {
        if (groups) {
            let groupSelects = []
            groups.forEach(g => {
                groupSelects.push({value: g.id, label: g.name})
            })
            setGroupSelectOptions([...groupSelects])
        }
    }, [groups]);

    const onCloseModal = (success, message) => {
        setGroupName("")
        setCreateNewGroup(true)
        setGroupSelectId("")
        setTab("")
        setLevel("1")
        return onClose(success, message)
    }
    const onAddCandidateIntoGroup = () => {
        if (isCreateNewGroup) {
            if (!groupName) {
                alert('Vui lòng nhập tên saved list')
                return
            }
            if (!tab) {
                alert('Vui lòng chọn tab')
                return
            }
            if (!level) {
                alert('Vui lòng chọn level')
                return
            }
        }
        setIsLoading(true)
        requestAddCandidateIntoGroup(
            {candidate_id: candidateId || '', group_id: groupSelectId, group_name: groupName, tab: tab.id, level: level}
        ).then((res) => {
            console.log(`Response-create candidate:${JSON.stringify(res)}`);
            if (res.sts_code === ResponseCode.SUCCESS) {
                const successMessage = createNewGroup ? "Tạo saved list mới thành công" : 'Thêm person vào Saved List thành công';
                onCloseModal(true, successMessage)
            } else if (res.sts_code === ResponseCode.EXISTS_SAVED_LIST) {
                showMessage("Tên saved list đã tồn tại trên phần mềm", false, true, true)
            } else {
                const errorMessage = createNewGroup ? "Tạo saved list mới thất bại" : 'Thêm person vào Saved List thất bại'
                showMessage(errorMessage, false, true, true)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onChangeGroupSelect = (event) => {
        if (event.target.value === 'new') {
            // Create new save list
            setCreateNewGroup(true)
        } else {
            setCreateNewGroup(false)
        }
        setGroupSelectId(event.target.value)
    }

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={onCloseModal}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Thêm person vào saved list</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        {!createNewGroup &&
                        <>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}>Person ID: {candidateId}</label>
                            </div>

                            <div className='input-group mt-3'>
                                <div className='col-sm-12'>
                                    <label className={'w-100'}>Chọn Saved List</label>
                                    <select className='form-control'
                                            name={'group'}
                                            value={groupSelectId}
                                            onChange={event => onChangeGroupSelect(event)}>
                                        <option value='new'>Tạo mới saved list</option>
                                        {groupSelectOptions.map(item => (
                                            <option value={item.value}
                                                    key={`group-select1-${item.value}`}>{item.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </>
                        }
                        {isCreateNewGroup &&
                            <>
                                <div className='input-group mt-3'>
                                    <div className='col-sm-12'>
                                        <div className='form-group'>
                                            <input type='text' className='form-control' placeholder='Tên saved list'
                                                   value={groupName}
                                                   name={'groupName'} onChange={event => setGroupName(event.target.value)}/>
                                        </div>
                                    </div>
                                </div>
                                <div className='input-group'>
                                    <div className='col-sm-12'>
                                        <div className='form-group'>
                                            <div style={{width: '100%'}}>
                                                <Select options={SavedListTabOptions}
                                                        value={tab}
                                                        name={'tab'}
                                                        placeholder={'Tên Tab'}
                                                        onChange={value => {
                                                            setTab(value);
                                                        }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='input-group'>
                                    <div className='col-sm-12'>
                                        <select className={`form-control`}
                                                value={level}
                                                name={'level'}
                                                onChange={event => setLevel(event.target.value)}>
                                            <option value={''}>{'Chọn level'}</option>
                                            {SavedListLevels.map(item => (
                                                <option value={item}>{item}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type='button'
                            className='btn btn-primary'
                            isLoading={isLoading}
                            disabled={
                                isLoading
                            }
                            onClick={() => {
                                onAddCandidateIntoGroup()
                            }}
                            >
                        <i className='fas fa-save mr-2'/>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AddCandidateIntoGroupModal;
